import React from 'react';

import './Spinner.scss';

type SpinnerComponentProps = {
  id?: string;
  variant?: 'primary' | 'default';
};

// reusable spinner component
function Spinner({ id = 'spinner', variant = 'default' }: SpinnerComponentProps) {
  return (
    <div className={`spinner spinner__${variant}`} id={id}>
      <div className={'spinner__bounce1'} />
      <div className={'spinner__bounce2'} />
      <div className={'spinner__bounce3'} />
    </div>
  );
}

export default Spinner;
